<template>
  <div class="reward" :class="{lan_En : lan != 'zh'}">
    <div class="content content1">
      <div class="cont1 hide">
        <div class="icon1"></div>
        <div class="icon2"></div>
        <div class="icon3"></div>
        <div class="title">{{$t('reward.title1')}}</div>
        <p class="desc1">{{$t('reward.desc1')}}</p>
        <div class="title title1">{{$t('reward.title2')}}</div>
        <div class="text">
          <p class="desc1">{{$t('reward.text1')}}</p>
          <p class="desc1">{{$t('reward.text2')}}</p>
          <p class="desc1">{{$t('reward.text3')}}</p>
          <p class="desc1">
            {{$t('reward.text4_1')}}
            <a href="https://discord.gg/EuTXWRmg5Z"> Discord </a>
            {{$t('reward.text4_2')}}
            <a href="https://t.me/deeplinkglobal"> Telegram </a>
            {{$t('reward.text4_3')}}</p>
        </div>
        <div class="btn">{{$t('reward.btntext')}}</div>
        <div class="desc3">{{$t('reward.text5')}}</div>

        <div class="tips">
          <div class="tip1">
            <p class="fs24 color2">1</p>
            <p class="fs14 color3">{{$t('reward.text6_1')}} <br> {{$t('reward.text6_2')}}</p>
          </div>
          <div class="tip2">
            <p class="fs16 color4">{{$t('reward.text7')}}</p>
            <p class="fs24 color1">10000</p>
            <p class="fs16 color2">{{$t('reward.text8')}}</p>
          </div>
          <div class="tip1 tip3">
            <p class="fs24 color1">1000 <span class="fs12 color5">USD</span></p>
            <p class="fs14 color3">{{$t('reward.text9')}}</p>
          </div>
          <div class="tip1 tip4">
            <p class="fs24 color2">100</p>
            <p class="fs14 color3">{{$t('reward.text10_1')}} <br> {{$t('reward.text10_2')}}</p>
          </div>
          <div class="tip1 tip5">
            <p class="fs24 color1">10000 <span class="fs12 color5">USD</span></p>
            <p class="fs14 color3">{{$t('reward.text11')}}</p>
          </div>
        </div>
      </div>
      <div class="cont1 show">
        <div class="icon1"></div>
        <div class="icon2"></div>
        <div class="icon3"></div>
        <div class="tips">
          <div class="tip1">
            <p class="fs24 color2">1</p>
            <p class="fs14 color3">{{$t('reward.text6_1')}} <br> {{$t('reward.text6_2')}}</p>
          </div>
          <div class="tip2">
            <p class="fs16 color4">{{$t('reward.text7')}}</p>
            <p class="fs24 color1">10000</p>
            <p class="fs16 color2">{{$t('reward.text8')}}</p>
          </div>
          <div class="tip1 tip3">
            <p class="fs24 color1">1000 <span class="fs12 color5">USD</span></p>
            <p class="fs14 color3">{{$t('reward.text9')}}</p>
          </div>
          <div class="tip1 tip4">
            <p class="fs24 color2">100</p>
            <p class="fs14 color3">{{$t('reward.text10_1')}} <br> {{$t('reward.text10_2')}}</p>
          </div>
          <div class="tip1 tip5">
            <p class="fs24 color1">10000 <span class="fs12 color5">USD</span></p>
            <p class="fs14 color3">{{$t('reward.text11')}}</p>
          </div>
        </div>
        <div class="btn">{{$t('reward.btntext')}}</div>
        <div class="desc3">{{$t('reward.text5')}}</div>
        <div class="title">{{$t('reward.title1')}}</div>
        <p class="desc1">{{$t('reward.desc1')}}</p>
        <div class="title title1">{{$t('reward.title2')}}</div>
        <div class="text">
          <p class="desc1">{{$t('reward.text1')}}</p>
          <p class="desc1">{{$t('reward.text2')}}</p>
          <p class="desc1">{{$t('reward.text3')}}</p>
          <p class="desc1">
            {{$t('reward.text4_1')}}
            <a href="https://discord.gg/EuTXWRmg5Z"> Discord </a>
            {{$t('reward.text4_2')}}
            <a href="https://t.me/deeplinkglobal"> Telegram </a>
            {{$t('reward.text4_3')}}</p>
        </div>
      </div>
    </div>
    <div class="content content2">
      <!-- <img class="bg" src="../assets/reward_bg2.png" alt=""> -->
      <div class="cont2">
        <div class="icon1"></div>
        <div class="icon2"></div>
        <div class="details min_h124">
          <div class="number">1</div>
          <div class="title">{{$t('reward.text12')}}</div>
          <div>{{$t('reward.text13')}}</div>
        </div>
        <div class="details min_h124">
          <div class="number">2</div>
          <div class="title">{{$t('reward.text14')}}</div>
          <div>{{$t('reward.text15')}}</div>
        </div>
        <div class="details min_h146">
          <div class="number">3</div>
          <div class="title">{{$t('reward.text16')}}?</div>
          <div>{{$t('reward.text17')}}</div>
        </div>
        <div class="details min_h146">
          <div class="number">4</div>
          <div class="title">{{$t('reward.text18')}}</div>
          <div>{{$t('reward.text19')}}</div>
        </div>
        <div class="details min_h215">
          <div class="number">5</div>
          <div class="title">{{$t('reward.text20')}}</div>
          <div>{{$t('reward.text21')}}</div>
        </div>
        <div class="details min_h215">
          <div class="number">6</div>
          <div class="title">{{$t('reward.text22')}}</div>
          <div>{{$t('reward.text23')}} <a href="https://www.deepbrainchain.org">https://www.deepbrainchain.org</a></div>
        </div>
        <div class="details">
          <div class="number">7</div>
          <div class="title">{{$t('reward.text24')}}</div>
          <div>
            <p>{{$t('reward.details.text1')}}</p>
            <p>{{$t('reward.details.text2')}}</p>
            <p>{{$t('reward.details.text3')}}</p>
            <p>{{$t('reward.details.text4')}}</p>
            <p>{{$t('reward.details.text5')}}</p>
            <p>{{$t('reward.details.text6')}}</p>
            <p>{{$t('reward.details.text7')}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { defineComponent, computed } from "vue";
  import { useStore } from "vuex"
  export default defineComponent({
    name: 'Reward',
    setup() {
      const store = useStore()
      let lan = computed(() => {
        return store.state.lan
      })
      return {
        lan
      };
    }
  })
</script>

<style lang="scss" scoped>
.reward {
  width: 100%;
  font-style: normal;
  font-family: 'Rubik, sans-serif';
  .content {
    position: relative;
    width: 100%;
    min-width: 1200px;
    font-size: 0;
    line-height: 0;
    .show {
      display: none;
    }
    .hide {
      display: block;
    }
    &.content1 {
      height: 838px;
      background: url("../assets/reward_bg1.png") no-repeat center;
      background-size: 100% 838px;
    }
    &.content2 {
      height: 1000px;
      background: url("../assets/reward_bg2.png") no-repeat center;
      background-size: 100% 1000px;
    }
    .cont1 {
      position: relative;
      min-width: 1200px;
      max-width: 1440px;
      margin: auto;
      font-weight: 500;
      box-sizing: border-box;
      padding: 160px 0 0 150px;
      background: url("../assets/reward.png") no-repeat center;
      background-size: 400px 400px;
      background-position: 840px 130px;
      .icon1 {
        position: absolute;
        top: 50px;
        left: 340px;
        width: 160px;
        height: 160px;
        background: url('../assets/icon10.png') no-repeat 100%/100%;
        opacity: .8;
      }
      .icon2 {
        position: absolute;
        top: 15px;
        left: 1030px;
        width: 133px;
        height: 133px;
        background: url('../assets/icon2.png') no-repeat 100%/100%;
        opacity: .6;
      }
      .icon3 {
        position: absolute;
        top: 645px;
        left: 1220px;
        width: 133px;
        height: 133px;
        background: url('../assets/icon3.png') no-repeat 100%/100%;
        opacity: .6;
      }
      .title {
        font-size: 40px;
        color: #363F5E;
        line-height: 53px;
        margin-bottom: 15px;
        font-family: 'OPPOSans';
        &.title1 {
          margin-top: 40px;
        }
      }
      .desc1 {
        font-size: 14px;
        line-height: 28px;
        color: rgba(54, 63, 94, 0.8);
      }
      .text {
        width: 600px;
      }
      .btn {
        font-size: 18px;
        color: #FFFFFF;
        cursor: pointer;
        text-align: center;
        padding: 20px 50px;
        border-radius: 58px;
        margin: 30px 0 20px;
        display: inline-block;
        // background: linear-gradient(271.98deg, #2AB36A 4.13%, rgba(104, 204, 79, 0.8) 114.86%);
        background: #ccc;
      }
      .desc3 {
        font-size: 14px;
        line-height: 24px;
        color: rgba(54, 63, 94, 0.5);
      }
      .tips {
        position: absolute;
        top: 425px;
        left: 754px;
        text-align: center;
        width: 700px;
        .tip1 {
          position: absolute;
          display: flex;
          opacity: 0.75;
          padding: 12px 30px;
          background: #FFF;
          border-radius: 296px;
          flex-direction: column;
          box-shadow: 0px 6px 30px rgba(54, 63, 94, 0.08);
        }
        .tip2 {
          position: absolute;
          left: 168px;
          top: 70px;
          display: flex;
          padding: 12px 56px;
          background: #FFF;
          border-radius: 296px;
          flex-direction: column;
          box-shadow: 0px 6px 30px rgba(54, 63, 94, 0.1);
        }
        .tip3 {
          left: 450px;
          top: 30px;
        }
        .tip4 {
          top: 180px;
          left: 30px;
        }
        .tip5 {
          top: 200px;
          left: 330px;
        }
        .fs14 {
          font-size: 14px;
        }
        .fs24 {
          font-size: 24px;
        }
        .color1 {
          font-weight: 500;
          line-height: 34px;
          line-height: 1;
          color: #363F5E;
        }
        .color2 {
          font-weight: 500;
          line-height: 1;
          // line-height: 34px;
          color: rgba(54, 63, 94, 0.8);
        }
        .color3 {
          font-weight: 400;
          // line-height: 20px;
          line-height: 1;
          color: rgba(54, 63, 94, 0.4);
        }
        .color4 {
          font-weight: 500;
          line-height: 22px;
          color: rgba(54, 63, 94, 0.5);
        }
        .color5 {
          font-weight: 400;
          line-height: 17px;
          color: rgba(54, 63, 94, 0.3);
        }
        .fs16 {
          font-size: 16px;
        }
        .fs12 {
          font-size: 16px;
        }
      }
    }
    .cont2 {
      position: relative;
      width: 1200px;
      margin: auto;
      display: flex;
      flex-wrap: wrap;
      font-weight: 500;
      padding: 96px 0 0;
      box-sizing: border-box;
      justify-content: space-between;
      .icon1 {
        position: absolute;
        top: -55px;
        left: -55px;
        width: 105px;
        height: 105px;
        background: url('../assets/icon4.png') no-repeat 100%/100%;
      }
      .icon2 {
        position: absolute;
        top: 625px;
        left: 1100px;
        width: 120px;
        height: 120px;
        background: url('../assets/icon5.png') no-repeat 100%/100%;
      }
      .details {
        position: relative;
        width: 590px;
        font-size: 14px;
        font-weight: 500;
        line-height: 24px;
        margin-bottom: 20px;
        border-radius: 12px;
        box-sizing: border-box;
        padding: 20px 17px 20px 54px;
        color: rgba(54, 63, 94, 0.8);
        background: linear-gradient(0deg, rgba(255, 255, 255, 0.352) 0%, rgba(255, 255, 255, 0.88) 67.57%);
        .number {
          position: absolute;
          top: 20px;
          left: 20px;
          width: 24px;
          height: 24px;
          color: #FFF;
          font-size: 14px;
          font-weight: 400;
          line-height: 24px;
          text-align: center;
          border-radius: 100%;
          background: rgba(54, 63, 94, 0.8);
        }
        .title {
          font-size: 18px;
          font-weight: 400;
          color: #363F5E;
          line-height: 24px;
          margin-bottom: 10px;
        }
      }
      .min_h124 {
        min-height: 124px;
      }
      .min_h146 {
        min-height: 124px;
      }
      .min_h215 {
        min-height: 124px;
      }
    }
  }
}

.lan_En.reward {
  .content {
    // word-break: break-all;
    &.content2 {
      height: inherit;
      background-size: 100% 100%;
      // height: 1100px;
      // background-size: 100% 1100px;
    }
    .cont1 {
      .tips {
        .tip2 {
          top: 90px;
        }
        .tip3 {
          top: 10px;
        }
      }
    }
    .cont2 {
      .icon2 {
        top: 750px;
      }
      .desc3 {
        padding: 25px 5px 0;
        .tip1 {
          font-size: 16px;
          line-height: 24px;
        }
        .tip2 {
          font-size: 12px;
          line-height: 18px;
        }
      }
      .line {
        height: 80px;
      }
      .branch {
        margin: 25px auto 0;
      }
      .tree {
        .leaf {
          .line1 {
            height: 30px;
          }
          .icon {
            margin-bottom: 10px;
          }
          .text {
            height: 220px;
            padding: 10px 5px;
            font-size: 12px;
            line-height: 14px;
            p {
              margin-bottom: 0;
            }
            .title {
              font-size: 14px;
              line-height: 16px;
              margin-bottom: 10px;
            }
          }
        }
        .group {
          position: absolute;
          bottom: -30px;
          width: 58px;
          height: 12px;
        }
        .group1 {
          left: -15px;
        }
        .group2 {
          right: -15px;
        }
      }
    }
    .cont3 {
      p {
        margin-bottom: 5px;
      }
      .table {
        height: 160px;
        .li {
          height: 160px;
          padding: 10px;
          .title {
            line-height: 18px;
          }
          .desc {
            line-height: 14px;
          }
        }
      }
    }
    .cont4 {
      .desc2 {
        .tip {
          height: 150px;
          padding: 10px 10px 0;
        }
      }
    }
    .cont6 {
      .contimg {
        .block1 {
          .span {
            padding: 25px 5px 0;
            line-height: 14px;
            .title {
              font-size: 14px;
              line-height: 18px;
            }
          }
        }
        .block2 {
          .span {
            padding: 50px 20px 0;
            .title {
              font-size: 22px;
            }
          }
          .active {
            padding: 50px 20px 0;
            .title {
              font-size: 22px;
            }
          }
        }
        .block3{
          .span {
            padding: 30px 5px 0;
            line-height: 14px;
            .title {
              font-size: 14px;
              line-height: 18px;
            }
          }
        }
      }
      .details {
        .detail_con {
          .block {
            .title {
              font-size: 18px;
              line-height: 24px;
            }
            .text1 {
              font-size: 12px;
              line-height: 16px;
            }
            &.text {
              padding: 10px;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1400px){
  .reward {
    .content {
      .cont1 {
        padding: 100px 0 0 50px;
        background-position: 610px 130px;
        .icon1 {
          top: -20px;
          left: 100px;
        }
        .icon2 {
          left: 930px;
        }
        .icon3 {
          left: 1000px;
        }
        .text {
          width: 400px;
        }
        .tips {
          width: 600px;
          left: 530px;
        }
      }
      .cont2 {
        .icon1 {
          left: 50px;
        }
        .icon2 {
          left: 1000px;
        }
        .details {
          width: 570px;
        }
      }
    }
  }
  .lan_En.reward {
    .content {
      .cont1 {
        .tips {
          .tip2 {
            left: 25%;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1200px){
  .reward {
    width: 100%;
    min-width: 600px;
    .content {
      position: relative;
      margin-top: -2px;
      min-width: 600px;
      width: 100%;
      font-size: 0;
      line-height: 0;
      &.content1 {
        height: inherit;
        background: url('../assets/reward_bg1.png') no-repeat center;
        background-size: 100% 100%;
      }
      &.content2 {
        height: inherit;
        background: linear-gradient(180deg, #363F5E 52.12%, rgba(54, 63, 94, 0.9) 100%);
      }
      .show {
        display: block;
      }
      .hide {
        display: none;
      }
      .cont1 {
        position: relative;
        margin: auto;
        min-width: unset;
        width: 100%;
        text-align: center;
        font-weight: 500;
        height: inherit;
        overflow: hidden;
        padding: 0 0 130px;
        background: url("../assets/reward.png") no-repeat center;
        background-size: 400px 400px;
        background-position-y: 150px;
        .icon1 {
          position: absolute;
          top: 70px;
          left: 60px;
          width: 112px;
          height: 112px;
          transform: rotate(40deg);
          background: url('../assets/icon1.png') no-repeat 100%/100%;
        }
        .icon2 {
          position: absolute;
          top: 93px;
          right: 100px;
          left: unset;
          width: 133px;
          height: 133px;
          background: url('../assets/icon2.png') no-repeat 100%/100%;
          opacity: .6;
        }
        .icon3 {
          position: absolute;
          top: 668px;
          left: unset;
          right: 60px;
          width: 133px;
          height: 133px;
          background: url('../assets/icon3.png') no-repeat 100%/100%;
          opacity: .6;
        }
        .desc1 {
          width: 85%;
          margin: auto;
        }
        .tips {
          position: relative;
          top: unset;
          left: unset;
          width: 100%;
          margin-top: 400px;
          .tip1 {
            left: 10%;
          }
          .tip2 {
            position: absolute;
            left: 30%;
            top: 110px;
            margin: auto;
            display: flex;
            padding: 12px 56px;
            background: #FFF;
            border-radius: 296px;
            flex-direction: column;
            box-shadow: 0px 6px 30px rgba(54, 63, 94, 0.1);
          }
          .tip3 {
            left: unset;
            right: 10%;
            top: 30px;
          }
          .tip4 {
            top: 220px;
            left: 15%;
          }
          .tip5 {
            top: 230px;
            right: 15%;
            left: unset;
          }
        }
        .btn {
          margin: 340px 0 20px;
        }
        .title {
          font-size: 30px;
          margin-top: 40px;
        }
        .text {
          width: 100%;
          margin: auto;
        }
      }
      .cont2 {
        position: relative;
        margin: auto;
        width: 80%;
        padding-top: 40px;
        text-align: left;
        justify-content: center;
        .icon1 {
          display: none;
        }
        .icon2 {
          display: none;
        }
        p {
          margin-bottom: 5px;
        }
        .desc1 {
          font-weight: 600;
          font-size: 24px;
          line-height: 42px;
          color: #FFFFFF;
        }
        .desc2 {
          font-weight: 400;
          font-size: 16px;
          line-height: 22px;
          margin-bottom: 20px;
          color: rgba(255, 255, 255, 0.88);
        }
        .desc3 {
          width: 420px;
          height: 120px;
          margin: auto;
          font-weight: 600;
          padding-top: 27px;
          text-align: center;
          box-sizing: border-box;
          background: url(../assets/tree.png) no-repeat 100%/100%;
          .tip1 {
            color: #FFF;
            font-size: 24px;
            line-height: 33px;
          }
          .tip2 {
            font-size: 18px;
            line-height: 25px;
            color: #44FF55;
          }
        }
        .line {
          position: absolute;
          top: 250px;
          left: 0;
          right: 0;
          width: 3px;
          margin: auto;
          height: 50px;
          background: url(../assets/line.png) no-repeat 100%/100%;
        }
        .branch {
          position: relative;
          width: 64%;
          height: 0;
          margin: 50px auto 0;
          border-top: 2px dashed rgba(4, 180, 116, 0.68);
        }
        .tree {
          position: relative;
          width: 100%;
          display: flex;
          margin: auto;
          flex-wrap: wrap;
          justify-content: center;
          .leaf {
            width: 28%;
            margin: 0 2%;
            text-align: center;
            &.leaf2 {
              margin-top: -300px;
            }
            .line1 {
              width: 3px;
              margin: auto;
              height: 51px;
              background: url(../assets/line.png) no-repeat 100%/100%;
            }
            .line2 {
              height: 330px;
              background-repeat: repeat-y;
            }
            .icon {
              width: 52px;
              height: 52px;
              margin-bottom: 15px;
            }
            .text {
              width: 100%;
              height: 180px;
              padding: 10px;
              font-weight: 400;
              font-size: 12px;
              line-height: 18px;
              text-align: justify;
              border-radius: 12px;
              box-sizing: border-box;
              border: 1px solid rgba(255, 255, 255, 0.45);
              color: rgba(255, 255, 255, 0.6);
              background: linear-gradient(0deg, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0.016) 96.01%);
              .title {
                width: 100%;
                height: 40px;
                font-weight: 600;
                font-size: 16px;
                line-height: 20px;
                text-align: center;
                color: #44FF55;
                margin-bottom: 10px;
              }
            }
          }
        }
      }
    }
  }
  .lan_En.reward {
    .content {
      &.content2 {
        height: inherit;
        background: linear-gradient(180deg, #363F5E 52.12%, rgba(54, 63, 94, 0.9) 100%);
      }
      .cont1 {
        .tips {
          .tip2 {
            left: 25%;
          }
        }
      }
    }
  }
}

</style>

